<template>
    <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="pop-content-search">
        <el-form size="mini" label-width="100px" style="margin-left: -50px; margin-right: -30px;">
            <el-row :gutter="24" style="width: 100%;">
                <el-col :span="10">
                    <el-form-item label="제품군">
                        <el-input type="text" v-model="form.modelGroupNm" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="모델명">
                        <el-input type="text" v-model="form.modelNm" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="save()">
                        저장
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
        <!-- <div class="field has-addons ">
          <div class="mr20">
            <span class="pop-c-name">제품군</span>
          </div>
          <div class="control is-expanded" style="display: flex;">
            <input class="form-input" type="text" v-model="form.modelGroupNm" disabled>
          </div>
          <div class="mr20">
            <span class="pop-c-name">모델명</span>
          </div>
          <div class="control is-expanded" style="display: flex;">
            <input class="form-input" type="text" v-model="form.modelNm" disabled>
          </div>
          
          <div class="btn-wrap btn-type1 clearfix">
            <button type="submit" class="btn-size btn-blue fl_left" @click="save()">
                <span class="btn-icon"><i class="fas fa-save"></i></span>
                저장
            </button>
            </div>

        </div> -->
      </div>

      <div class="grid-wrap">
        <div class="talbe-contain" style="display: flex;border: 1px solid #a6acb1;border-radius: 3px;">
            <div class="table-area" style="margin-right: 20px; width: 30%;">
                <div class="table-b">
                    <el-tree class="custom-tree" :data="treeData" :props="defaultProps" @node-click="handleNodeClick" node-key="catId" :default-expanded-keys="this.form.expandIds">
                    </el-tree>
                </div>
            </div>
            <div class="table-area" style="margin-right: 20px; width: 70%">
                <div class="table-b">
                    <ag-grid-vue 
                    style="width: 100%; height: 330px;"
                    class="ag-theme-alpine"    
                    row-selection="single"
                    :framework-components="frameworkComponents"
                    :column-defs="columnDefs"     
                    :grid-options="gridOptions"
                    :row-data="rowData"
                    :default-col-def="defaultColDef"
                    @cell-value-changed="CellValueChange"
                    @grid-ready="onGridReady"/>
                </div>
            </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';

/**
 * * AG-Grid components
 */
import {AgGridVue} from 'ag-grid-vue';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';

function _url(...args) {
  args = args.map(x => String(x || '').trim().replace(/^\/*|\/*$/g, ''))
  args = args.filter(x => x)
  return args.join('/')
}

function getTreeData(array){
    var map = {};
    for(var i = 0; i < array.length; i++){
        var obj = {"catId" : array[i]['catId'], "label" : array[i]['catNm'], "catKey" : array[i]['catKey'], "LVL" : array[i]['catLvl']};
        obj.children = [];
        map[obj.catId] = obj;
        var parent = array[i]['parentId'] || '-';

        if(!map[parent]){
            map[parent] = {
                children: []
            };
        }
        map[parent].children.push(obj);
    }

    return map['-'].children;
}

export default {
    components: {Layout,AgGridVue},
    props: {
        data: {
            Type: Object
            , required: false
        },
    },
    data() {
        return {
            title: '고장증상선택',
            form: {
                expandId: '',
                expandIds: [],
                modelGroup: '',
                modelGroupNm: '',
                modelNm: ''
            },
            // AG-GRID OPTION [START]
            rowData:[],
            gridOptions: {},
            frameworkComponents : {
                'checkBox': CheckboxCellRenderer,
            },
            columnDefs:[
                {
                    headerName:'선택', 
                    field:'chk', 
                    width:80,
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: true    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: false  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName: '고장증상구분', 
                    field:'gbCd', 
                    width: 230,
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '고장증상명', 
                    field:'gbNm', 
                    width: 450,
                    cellStyle:{textAlign:'left'}
                },
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            selChkList: [],
            // el-tree data
            treeData: [{
                label: 'LCD(일반)',
                children: [{
                    label: '가구',
                },
                {
                    label: '음성',
                },
                {
                    label: '입출력',
                },
                {
                    label: '전원',
                },
                {
                    label: '화면',
                },
                {
                    label: '기타',
                },]
            }],
            defaultProps: {
                children: 'children',
                label: 'label'
            }
            // AG-GRID OPTION [END]
        }
    },
    created() {
        this.form = this.data;
        // this.rowData = [{chk: 'N', gbCd: '기구', gbNm: '외관불량'}, {chk: 'Y', gbCd: '기구', gbNm: '착탈불량'}];
    },
    mounted() {
        this.form = this.data.selModelObj
        console.log('model break this data: ', this.data)
        //pop slots modal move
        $(".animation-content").addClass('pop_min2');
        $(".animation-content").draggable({'cancel':'.modal-card-body'});
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '4');
    },
    destroyed() {
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '7');
    },
    methods: {
        changeTab(params) {
            this.viewer = params.tabId;
        },
        closeModal() {
            console.log(this.$parent)
            this.$parent.close();
        },
        handleNodeClick(param) {
            console.log(param);
            if(param.LVL === 3){
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.catKey}})
                .then(response => {
                    // console.log('modelBreak response.data : ', response.data)

                    this.rowData = response.data.map(x=>{
                        x.chk =  'N'
                        x.gbCd = param.label
                        x.gbNm = x.value
                        x.asCatId = x.key

                        return x
                    })
                });
            } else {
                this.rowData = []
            }
        },

        onGridReady(){
            this.goFailureModel()
        },
        CellValueChange(params){
            const idx = params.rowIndex;

            if(params.colDef.field === 'chk'){
                let vSelObj = this.selChkList || []

                if(params.data.chk === 'Y'){
                    const vparam = {
                    ...params.data,
                    id: params.node.id
                    }
                    vSelObj.push(vparam)
                } else {
                    vSelObj = vSelObj.filter(v => v.asCatId != params.data.asCatId)
                }

                this.selChkList = vSelObj

                console.log('selListChange  this.selChkList===:', this.selChkList)
            }
        },
        onCellClicked(params) {
            const field = params.colDef.field;
        },
        goFailureModel(){
          // this.$store.commit('loading')
          const vform = {
                companyId: this.$store.state.loginInfo.compCd || '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            };

          this.$http.post(_url("/api/asMng/popup/asCatSelect"), vform
                ).then(response => {
                console.log('catSelUseAll response.data' , response.data);
                
                response.data.unshift({catLvl:'0', catId:'140', parentId:'', topKey:'', topKeyNm:'', catKey:'140', catNm:'전체'});
                response.data
                    .map((x,index)=>{
                    x.catId = 'ID' + x.catId // 주의 : id값에 문자도 포함되어야 함.
                    x.parentId = index > 0 ? 'ID' + x.parentId : ''
                        
                    return x
                });

                let vLimitYn = 'N'; // 제한된 모델그룹 표시여부
                let vKeyPath = '';
                console.log('this.form.modelGroup ====', this.form.modelGroup);
                if(this.form.modelGroup && this.form.modelGroup.length>0){
                    const vExpandObj = response.data.filter(x=>x.catLvl===2 && x.catValue1==this.form.modelGroup);
                    //const vExpand2Obj = response.data.filter(x=>x.catLvl===2);
                    // console.log('vExpand2Obj ==== ', vExpandObj, vExpand2Obj);
                    // console.log('vExpandObj ==== ', this.form.modelGroup, vExpandObj);
                    if(vExpandObj && vExpandObj.length>0){
                        this.form.expandIds = [vExpandObj[0].catId];
                        vLimitYn = 'Y';
                        vKeyPath = vExpandObj[0].keyPath;

                        // console.log('vKeyPath: ', vKeyPath)
                    } else {
                        this.form.expandIds = ['ID140'];
                    }
                } else {
                    this.form.expandIds = ['ID140'];
                }
                
                
                /** tree생성 샘플 데이타 예시 
                     * 주의 : id는 문자도 포함되어 있어야 함.
                response.data = [{catId:'root', catLvl:'1',   parentId:'', catNm:'전체'},
                                {catId:'ID2', catLvl:'2',   parentId:'root', catNm:'대우'},
                                {catId:'ID3', catLvl:'3',   parentId:'ID2', catNm:'모니터1'},
                                {catId:'ID4', catLvl:'3',   parentId:'ID2', catNm:'모니터2'},
                                {catId:'ID5', catLvl:'2',   parentId:'root', catNm:'삼성'},
                                {catId:'ID6', catLvl:'3',   parentId:'ID5', catNm:'모니터1'}
                                ]
                 */

                let vData = [];
                if(vLimitYn === 'Y'){
                    vData = response.data.filter(x=>x.catLvl==0 || x.keyPath.indexOf(vKeyPath) != -1 );
                } else {
                    vData = response.data;
                }
                
                this.treeData = getTreeData(vData);
                 
            }).finally(() => {
                this.$store.commit('finish');
          });
        },
        save(){
            console.log('save start')
            let vSelObj = {
                data: this.selChkList
            }
            
            if(vSelObj.data.length > 0){
                this.$emit('close', vSelObj);
            }else{
                this.$swal({
                type: 'warning',
                text: '선택된 행이 없습니다.'
                });
            }
            
        }
    }

}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>